import { createGlobalStyle } from "styled-components";
import { normalize } from "styled-normalize";

import { FontFamilies, Colors } from "@paclife/plds.tokens";
import "./index.css";

const GlobalStyle = createGlobalStyle`
  ${normalize}
    
    * {
        margin: 0;
        padding: 0;
    }

    *,
    *:before,
    *:after {
        box-sizing: border-box;
    }

    a {
        display: inline-block;
        text-decoration: none;
    }

    a:visited {
        color: ${Colors.blue600}
    }
    
    svg {
        display: inline-block;
        vertical-align: middle;
    }

    ul, ol, li {
        list-style-type: none;
    }

    body {
        font-size: 16px;
        font-family: ${FontFamilies.openSans}, sans-serif;
        color: ${Colors.neutral1000};
        background-color: ${Colors.neutral0};
    }

`;

export default GlobalStyle;
